import React from 'react';
import _ from 'lodash';

export const queryParamsToObject = (search) => {
    return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
};

function setSelectedSubsection(sectionName, urlpart) {
    let currentAccount = null;
    const { match } = this.props;
    const { accounts } = this.state;
    let accountNumberParam = match.params.accountnumber;
    if (accountNumberParam) {
        //account param from browser query params
        currentAccount = accounts.find((a) => a.value === accountNumberParam);
        if (currentAccount) {
            this.props.accountSelected(currentAccount);
        }
    } else if (this.props.accountStore && this.props.accountStore.account) {
        //account from REDUX store
        currentAccount = accounts.find((a) => a.value === this.props.accountStore.account.value);
    } else {
        //first account in collection if it's not empty
        currentAccount = accounts.length > 0 ? this.state.accounts[0] : null;
        if (currentAccount) {
            this.props.accountSelected(currentAccount);
        }
    }
    this.setState({ selectedAccount: currentAccount }, () => {
        if (this.state.selectedAccount) {
            let url = `/${sectionName}/${this.state.selectedAccount.value}`;

            if (urlpart !== '') {
                url += `/${urlpart}`;
            }
            this.props.history.push(url);
        }
    });
}

function isClassComponent(component) {
    return typeof component === 'function' && !!component.prototype && !!component.prototype.isReactComponent
        ? true
        : false;
}

function isFunctionComponent(component) {
    return typeof component === 'function' && String(component).includes('return React.createElement') ? true : false;
}

function isReactComponent(component) {
    return isClassComponent(component) || isFunctionComponent(component) ? true : false;
}

function isElement(element) {
    return React.isValidElement(element);
}

function isDOMTypeElement(element) {
    return isElement(element) && typeof element.type === 'string';
}

function isCompositeTypeElement(element) {
    return isElement(element) && typeof element.type === 'function';
}

function difference(object, base) {
    function changes(object, base) {
        return _.transform(object, function (result, value, key) {
            if (!_.isEqual(value, base[key])) {
                result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
            }
        });
    }
    return changes(object, base);
}

const hashCode = (string) => {
    var hash = 0,
        i,
        chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
        chr = string.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

const trimStringFields = (obj) => {
    if (!obj) return obj;
    return Object.keys(obj).reduce((result, key) => {
        result[key] = typeof obj[key] === 'string' ? obj[key].trim() : obj[key];
        return result;
    }, {});
};

const createDownloadUrl = function (fileData) {
    var blob = new Blob([fileData], { type: 'application/pdf' });

    // create an object URL from the Blob
    var fileUrl = window.URL || window.webkitURL;
    var downloadUrl = fileUrl.createObjectURL(blob);
    return downloadUrl;
};

const revokeDownloadUrl = (downloadUrl) => {
    const fileUrl = window.URL || window.webkitURL;
    fileUrl.revokeObjectURL(downloadUrl);
};

const getDocumentFromUrl = (downloadUrl, fileName) => {
    var downloadLink = document.createElement('a');
    downloadLink.target = '_blank';
    downloadLink.download = fileName;
    downloadLink.href = downloadUrl;

    document.body.append(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    revokeDownloadUrl(downloadUrl);
};

const showInTab = (url, targetWindow) => {
    const win = targetWindow && !targetWindow.closed ? targetWindow : window.open('', '_blank');
    if (win) {
        try {
            win.opener = null;
            win.location.href = url;
            win.focus();
        } catch (error) {
            console.error('Error: ', error);
            return false;
        }
        return true;
    }
    return false;
};

const openLoadingTab = (loadingMessage = 'Loading PDF...') => {
    const win = window.open('', '_blank');
    if (!win) {
        return null;
    }

    try {
        win.opener = null;
        win.document.write(
            `<!DOCTYPE html><html><head><title>Loading</title></head><body><p>${loadingMessage}</p></body></html>`
        );
        win.document.close();
    } catch (error) {
        console.error('Error opening loading tab: ', error);
    }

    return win;
};

const getPdf = (fileData, fileName, isShowInTab, targetWindow = null) => {
    const objectUrl = createDownloadUrl(fileData);

    if (isShowInTab) {
        const openedInTab = showInTab(objectUrl, targetWindow);
        if (!openedInTab) {
            if (targetWindow && !targetWindow.closed) {
                targetWindow.close();
            }
            getDocumentFromUrl(objectUrl, fileName);
            return;
        }

        // Keep the blob URL alive long enough for the new tab to finish loading it.
        window.setTimeout(() => revokeDownloadUrl(objectUrl), 60000);
    } else {
        getDocumentFromUrl(objectUrl, fileName);
    }
};
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export {
    setSelectedSubsection,
    isReactComponent,
    isDOMTypeElement,
    isCompositeTypeElement,
    difference,
    hashCode,
    trimStringFields,
    getPdf,
    openLoadingTab,
    a11yProps,
};
